import * as Error from '../../../Previewer/utils/error';
import { serializeAnnotationArray } from './utils';

export class AnnotationManager {
    #annotationManager;
    constructor(pdfAnnotationManager) {
        this.#annotationManager = pdfAnnotationManager;
    }

    addInitialAnnotations = async(fadedAnnotations, annotationsHidden) => {
        if (fadedAnnotations.length && !annotationsHidden) {
            try {
                await this.#annotationManager.addAnnotations(serializeAnnotationArray(fadedAnnotations));
            }
            catch (err){
                Error.send(err.message, err.code,
                    {
                        failureLocation: 'PDF: Adobe embed sdk: addAnnotations in addInitialAnnotations failed',
                        fadedAnnotations
                    });
            }
        }
    }

    addAnnotations = (annotations) => {
        if (annotations.length){
            this.#annotationManager.addAnnotations(serializeAnnotationArray(annotations));
        }
    };

    getAnnotations = () => this.#annotationManager.getAnnotations();

    updateAnnotation = async(annotationData) => {
        try {
            await this.#annotationManager.updateAnnotation(serializeAnnotationArray([annotationData])[0]);
        }
        catch (err) {
            Error.send(err.message, err.code,
                {
                    failureLocation: 'PDF: Adobe embed sdk: updateAnnotation failed',
                    annotationData
                });
        }
    }

    deleteAnnotations = async(annotationIds) => {
        try {
            await this.#annotationManager.deleteAnnotations({ annotationIds });
        }
        catch (err){
            Error.send(err.message, err.code,
                {
                    failureLocation: 'PDF: Adobe embed sdk: deleteAnnotations failed',
                    annotationIds
                });
        }
    }

    unselectAnnotation = () => this.#annotationManager.unselectAnnotation();

    selectAnnotation = async(annotationId) => {
        try {
            await this.#annotationManager.selectAnnotation(annotationId);
        }
        catch (err){
            Error.send(err.message, err.code,
                {
                    failureLocation: 'PDF: Adobe embed sdk: selectAnnotation failed',
                    annotationId
                });
        }
    };
}
